import tagsLoader from '@/mixins/fetcher/loaders/orm/tags-loader';
import schemasLoader from '@/mixins/fetcher/loaders/schemas-loader';

export default {

  data() {
    return {
      debug: this.$store.get('debug/orm@debug'),
      showCount: this.$store.get('debug/orm@showCount'),
    };
  },

  mixins: [
    tagsLoader,
    schemasLoader,
  ],

  methods: {
    loadFetcherCache(fromDb) {
      /* ORM */
      this.loadTags(fromDb);
      /* ORM */
      /* DB */
      this.loadSchema('nav');
      this.loadSchema('filters');
      /* DB */
    },
  },

  mounted() {
    this.loadFetcherCache(false);

    Bus.$on('refresh_cache', () => {
      this.loadFetcherCache(true);
    });
  },

  beforeDestroy() {
    Bus.$off('refresh_cache');
  },
};
